import '../css/style.css';

document.getElementById('js-nav-trigger').addEventListener('click', () => {
    document.getElementById('js-nav').classList.toggle('header-nav--active');
});
